import watchSumbmitNumber from './submitNumber';

const watchCheckNumber = [watchSumbmitNumber];

export default watchCheckNumber;
